import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@material-ui/core';

const Paragraph = ({ content, variant }) => (
    <Typography variant={variant}>
        {content}
    </Typography>
);

export default Paragraph;

Paragraph.propTypes = {
    content: PropTypes.string,
    variant: PropTypes.string,
};

Paragraph.defaultProps = {
    content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id sodales risus.',
    variant: 'body1',
};
